import { Component } from "@angular/core";
import { Icon } from "../icon/icon.component";
import { BaseConfig } from "../common/config/config.adapter";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-hint",
    template: `
        <div class="flex items-start gap-2">
            <div class="min-w-4">
                <app-icon
                    name="solar:info-circle-bold-duotone"
                    size="sm"
                    class="flex text-gray-500"
                />
            </div>
            <p class="text-sm  whitespace-pre-line text-gray-500">
                <ng-content />
            </p>
        </div>
    `,
    imports: [Icon, CommonModule],
})
export class Hint extends BaseConfig {}
